import { firstDefined, getConfiguration, getMatchObject } from './galiDisplay';
import { normalizeGaliPlayerRef } from './galiPlayerRefs';

const hasPlayers = (team) => Array.isArray(team?.players) && team.players.length > 0;
const getPath = (payload, path) => path.reduce((acc, key) => acc?.[key], payload);
const teamSources = [
  { path: 'match.teamA/teamB', get: (payload) => (payload?.match?.teamA || payload?.match?.teamB ? { teamA: payload.match.teamA, teamB: payload.match.teamB } : null) },
  { path: 'teamA/teamB', get: (payload) => (payload?.teamA || payload?.teamB ? { teamA: payload.teamA, teamB: payload.teamB } : null) },
  { path: 'match.configuration.gali.teams', get: (payload) => getPath(payload, ['match', 'configuration', 'gali', 'teams']) },
  { path: 'configuration.gali.teams', get: (payload) => getPath(payload, ['configuration', 'gali', 'teams']) },
  { path: 'match.config.gali.teams', get: (payload) => getPath(payload, ['match', 'config', 'gali', 'teams']) },
  { path: 'config.gali.teams', get: (payload) => getPath(payload, ['config', 'gali', 'teams']) },
  { path: 'match.gali.teams', get: (payload) => getPath(payload, ['match', 'gali', 'teams']) },
  { path: 'gali.teams', get: (payload) => getPath(payload, ['gali', 'teams']) },
];

const normalizeTeam = (team, key, fallbackName) => {
  const captain = normalizeGaliPlayerRef(team?.captain || team?.captainRef);
  return {
    ...(team || {}),
    key,
    name: firstDefined(team?.name, fallbackName, key === 'teamA' ? 'Team A' : 'Team B'),
    captain,
    captainRef: normalizeGaliPlayerRef(team?.captainRef || team?.captain),
    players: (Array.isArray(team?.players) ? team.players : []).map(normalizeGaliPlayerRef).filter(Boolean),
  };
};

const findCommonPlayer = (payload, matchObject, configuration) => payload?.match?.commonPlayer
  || payload?.commonPlayer
  || matchObject?.commonPlayer
  || configuration?.gali?.commonPlayer
  || payload?.config?.gali?.commonPlayer
  || payload?.gali?.commonPlayer
  || { enabled: false, player: null };

export const getGaliTeams = (match = {}) => {
  const payload = match || {};
  const matchObject = getMatchObject(payload);
  const source = teamSources.find(({ get }) => {
    const teams = get(payload);
    return hasPlayers(teams?.teamA) || hasPlayers(teams?.teamB);
  }) || teamSources.find(({ get }) => {
    const teams = get(payload);
    return teams?.teamA || teams?.teamB;
  });
  const teams = source?.get(payload) || {};
  const configuration = getConfiguration(payload);
  const common = findCommonPlayer(payload, matchObject, configuration);
  return {
    teamA: normalizeTeam(teams.teamA, 'teamA', firstDefined(matchObject.team1, matchObject.teams?.team1, payload?.match?.teamA?.name, 'Team A')),
    teamB: normalizeTeam(teams.teamB, 'teamB', firstDefined(matchObject.team2, matchObject.teams?.team2, payload?.match?.teamB?.name, 'Team B')),
    commonPlayer: common?.enabled ? { ...common, enabled: true, player: normalizeGaliPlayerRef(common.player) } : { enabled: false, player: null },
    sourcePath: source?.path || 'none',
  };
};

export const hasGaliTeamPlayers = (teams = {}) => hasPlayers(teams.teamA) || hasPlayers(teams.teamB);
